// extracted by mini-css-extract-plugin
export default {"gravatar":"u7Hrb","gravatarFallback":"NiJAd","logoutButton":"Fmogo"};